import React from 'react'

const UserPlus = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 503.091 503.091" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M290.113 225.926c11.483 10.797 21.484 23.147 29.949 37.029 21.4-13.409 46.679-21.175 73.742-21.175 11.463 0 22.602 1.402 33.267 4.025-17.147-22.444-37.802-39.061-63.923-51.365-19.586 17.869-45.009 29.44-73.035 31.486zM254.517 381.066c0-38.878 16.018-74.08 41.793-99.372-14.52-25.166-34.336-44.125-60.078-57.466-21.211 14.602-46.886 23.164-74.527 23.164-27.561 0-53.168-8.512-74.343-23.037C33.73 253.36 0 313.724 0 383.426v106.928h307.547c-32.28-25.532-53.03-65.031-53.03-109.288zM293.465 115.632c0 28.223-8.923 54.399-24.091 75.862l.765 4.106c3.647.436 7.332.655 11.024.655 50.596 0 91.759-41.163 91.759-91.759 0-50.597-41.163-91.76-91.759-91.76a91.701 91.701 0 00-30.963 5.359c26.562 24.123 43.265 58.916 43.265 97.537z"
      />
      <ellipse fill={color} cx="161.706" cy="115.632" rx="101.76" ry="101.759" transform="rotate(-13.34 161.407 115.648)" />
      <path
        fill={color}
        d="M503.091 381.066c0-60.261-49.026-109.287-109.287-109.287s-109.287 49.026-109.287 109.287 49.026 109.287 109.287 109.287c60.261.001 109.287-49.025 109.287-109.287zm-172.942 15v-30h48.654v-48.654h30v48.654h48.654v30h-48.654v48.655h-30v-48.655z"
      />
    </svg>
  )
}

UserPlus.defaultProps = {
  size: 30,
  color: '#555555',
}

export default UserPlus
